import { render, staticRenderFns } from "./SupportApp.vue?vue&type=template&id=feb043f8"
import script from "./SupportApp.vue?vue&type=script&lang=js"
export * from "./SupportApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports